module.exports = __webpack_public_path__ + "static/media/android_badge_ch.cd5d4e76.svg";